module.exports = __webpack_public_path__ + "static/media/logo3.f41438d6.png";